__turbopack_context__.v({
  "rawNull__tiSaY": "PlasmicInfoSection-module__SZICTG__rawNull__tiSaY",
  "section": "PlasmicInfoSection-module__SZICTG__section",
  "sectionHeading": "PlasmicInfoSection-module__SZICTG__sectionHeading",
});
